import React from 'react'

const SubscriptionFailure = () => {
  
  return (
    <>
    <h1>SubscriptionFailure</h1>
    </>
  )
}

export default SubscriptionFailure